import { partnerService, Partner } from "./partnerService";

interface Line extends Partner {
  lineUserId?: string;
}

// Line service.
// This service is used to store and retrieve the Line object.
//
const partnerLineService = {
  isActive: () => {
    return !!getPartnerObject();
  },

  getReturnUrl: () => {
    // New implementation using Universal Link
    return "https://line.me/R/ti/p/@samitivej";

    // Previous implementation
    // return "https://liff.line.me/1645278921-kWRPP32q?accountId=samitivej&openerPlatform=native&openerKey=talkroom%3Aheader#mst_challenge=2-nNu-TFjpnqT3AECtA3vpW3vU3s61OQCSWBTxhGM7g";
  },

  onIndexMounted: (location: Location) => {
    const partner = getPartnerObject();
    if (!partner) return;

    // Store Line user ID if provided in query params
    const lineUserId = new URLSearchParams(location.search).get(
      "lineUserId"
    ) as string;
    if (lineUserId) {
      partner.lineUserId = lineUserId;
      setPartnerObject(partner);
    }
  },
};

const getPartnerObject = () => {
  const partner = partnerService.getPartner();
  if (partner && partner.name.toLowerCase() === "line") {
    return partner as Line;
  }
  return undefined;
};

const setPartnerObject = (partner: Line) => {
  partnerService.setPartner(partner);
};

export { partnerLineService };
